
export default {
  name: 'StretchPage',
  props: {
    top: {
      type: String,
      default: '-64px',
    },
  },
  methods: {
    setConf(data) {
      return data
    },
  },
}
